import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({'Accept': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.baseUrl;
  isLoggedIn = false;
  private logged = new ReplaySubject<boolean>(1);
  isLogged = this.logged.asObservable();

  constructor(private router: Router, private http: HttpClient) { }

  isAuthenticated() {
    return window.sessionStorage.getItem("auth-token") != null;
  }

  login(login: string, password: string, remote_ip: string, user_agent: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.post(url + 'login?login=' + login + '&password=' + password + '&remote_ip=' + remote_ip + '&user_agent=' + user_agent, httpOptions)
      .pipe(
        map((data) => {
          if (data) {
            // this.isAuthenticated();
            console.log('login data', data)
            this.logged.next(true);
          }
          return data;
        })
      );
  }

  reset(email: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get(url + 'reset?login=' + email, httpOptions);
  }

  confirmReset(token: string, new_password: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.post(url + 'reset?token=' + token + '&new_password=' + new_password, httpOptions)
  }

}
